var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { attrs: { content: _vm.actionLabel, placement: "top-start" } },
    [
      _c(
        "button",
        {
          staticClass: "sensitive-view-button",
          class: { "is-loading": _vm.loading },
          attrs: {
            type: "button",
            disabled: _vm.disabled || _vm.loading,
            "aria-label": _vm.actionLabel,
            "aria-pressed": String(_vm.revealed),
          },
          on: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _c("svg-icon", {
            attrs: { "icon-class": _vm.loading ? "loading" : "iconEye" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }